export const pillsNavigationDefaultConfig = [
  [
    'set1',
    [
      {
        value: 'ABC',
        link: '#set2',
      },
      {
        value: 'Teamsport',
        link: '#set2',
        filter: {
          fieldId: 'attributes.category',
          displayName: 'Teamsport',
          value: 'Teamsport',
        },
      },
      {
        value: 'GHI',
        link: '#set2',
      },
      {
        value: 'LIST',
        link: '/browse/product-lists/c1e4f66a-337b-441f-9ea4-584452956902/details',
      },
    ],
  ],
  [
    'set2',
    [
      {
        value: '111',
        link: '#set3',
      },
      {
        value: 'Accessories',
        link: '#set3',
        filter: {
          fieldId: 'attributes.category',
          displayName: 'Accessories',
          value: 'Accessories',
        },
      },
      {
        value: 'SEARCH',
        link: '/browse/search?f=attributes.productdivision:Apparel&start=0&num=25&preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: '444',
        link: '#set3',
      },
    ],
  ],
  [
    'set3',
    [
      {
        value: 'AAA',
        link: '#set4',
      },
      {
        value: 'SEARCH',
        link: '/browse/search?f=attributes.productdivision:Apparel&start=0&num=25&preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Cap',
        link: '#set4',
        filter: {
          fieldId: 'attributes.articletype',
          displayName: 'Cap',
          value: 'Cap',
        },
      },
      {
        value: 'LIST',
        link: '/browse/product-lists/c1e4f66a-337b-441f-9ea4-584452956902/details',
      },
    ],
  ],
  [
    'set4',
    [
      {
        value: 'SEARCH',
        link: '/browse/search?f=attributes.productdivision:Apparel&start=0&num=25&preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'B1B1',
        link: '#set5',
      },
      {
        value: 'Apparel',
        link: '#set6',
        filter: {
          fieldId: 'attributes.productdivision',
          displayName: 'Apparel',
          value: 'Apparel',
        },
      },
      {
        value: 'D1D1',
        link: '#set5',
      },
    ],
  ],
  [
    'set5',
    [
      {
        value: 'A2A2',
      },
      {
        value: 'Infant',
        filter: {
          fieldId: 'attributes.agegroup',
          displayName: 'Infant',
          value: 'Infant',
        },
      },
      {
        value: 'C2C2',
      },
      {
        value: 'LIST',
        link: '/browse/product-lists/c1e4f66a-337b-441f-9ea4-584452956902/details',
      },
    ],
  ],
];

export const pillsNavigationOneLevelConfig = [
  [
    'set1',
    [
      {
        value: 'AAA',
        link: '#set4',
      },
      {
        value: 'SEARCH',
        link: '/browse/search?f=attributes.productdivision:Apparel&start=0&num=25&preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'CCC',
        link: '#set4',
      },
      {
        value: 'LIST',
        link: '/browse/product-lists/c1e4f66a-337b-441f-9ea4-584452956902/details',
      },
    ],
  ],
];

export const pillsNavigationFemaleMaleKidsLevelConfig = [
  [
    'set1',
    [
      {
        value: 'Female',
        link: '/browse/search?q=&f=attributes.gender:Female&start=0&num=25&preset=now&sortField=Default&sortDirection=Desc&collapse=false',
      },
      {
        value: 'Male',
        link: '/browse/search?q=&f=attributes.gender:Male&start=0&num=25&preset=now&sortField=Default&sortDirection=Desc&collapse=false',
      },
      {
        value: 'Kids',
        link: '/browse/search?start=0&num=25&preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true&f=attributes.agegroup:Youth',
      },
    ],
  ],
];

export const pillsNavigationFiltersConfig = [
  [
    'set1',
    [
      {
        value: 'Accessories',
        link: '#set2',
      },
      {
        value: 'Apparel',
        link: '#set2',
      },
      {
        value: 'Footwear',
        link: '#set2',
      },
    ],
  ],
  [
    'set2',
    [
      {
        value: 'Accessories',
        link: '#set3',
      },
      {
        value: 'Basketball',
        link: '#set3',
      },
      {
        value: 'Run/train',
        link: '#set3',
      },
      {
        value: 'Running',
        link: '#set3',
      },
      {
        value: 'Sportstyle Core',
        link: '#set3',
      },
      {
        value: 'Sportstyle Kids',
        link: '#set3',
      },
      {
        value: 'Sportstyle Prime',
        link: '#set3',
      },
      {
        value: 'Teamsport',
        link: '#set3',
      },
    ],
  ],
  [
    'set3',
    [
      {
        value: 'Ball sacs',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Bb Cap',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Bb Caps 1',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Beanie',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Cap',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Dress',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Field Player Gloves',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Football Pants',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Football Shirt',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Football Socks',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Goalkeeper Gloves',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Goalkeeper Pants',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Insulated Jackets',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
      {
        value: 'Jerseys',
        link: '/browse/search?preset=now&sortField=Default&sortDirection=Desc&collapse=false&withRelatedVariants=true',
      },
    ],
  ],
];

export const pillsNavigationCustomFiltersConfig = [
  [
    'set1',
    [
      {
        value: 'Accessories',
        link: '#set2',
        filter: {
          fieldId: 'attributes.productdivision',
          displayName: 'Accessories',
          value: 'Accessories',
        },
      },
      {
        value: 'Apparel',
        link: '#set2',
        filter: {
          fieldId: 'attributes.productdivision',
          displayName: 'Apparel',
          value: 'Apparel',
        },
      },
      {
        value: 'Footwear',
        link: '#set2',
        filter: {
          fieldId: 'attributes.productdivision',
          displayName: 'Footwear',
          value: 'Footwear',
        },
      },
    ],
  ],
  [
    'set2',
    [
      {
        value: 'Running',
        link: '#set3',
        filter: {
          fieldId: 'attributes.category',
          displayName: 'Running',
          value: 'Running',
        },
      },
      {
        value: 'Teamsport',
        link: '#set3',
        filter: {
          fieldId: 'attributes.category',
          displayName: 'Teamsport',
          value: 'Teamsport',
        },
      },
    ],
  ],
  [
    'set3',
    [
      {
        value: 'Cap',
        filter: {
          fieldId: 'attributes.articletype',
          displayName: 'Cap',
          value: 'Cap',
        },
      },
      {
        value: 'Dress',
        filter: {
          fieldId: 'attributes.articletype',
          displayName: 'Dress',
          value: 'Dress',
        },
      },
      {
        value: 'Jerseys',
        filter: {
          fieldId: 'attributes.articletype',
          displayName: 'Jerseys',
          value: 'Jerseys',
        },
      },
    ],
  ],
];
